import { ActionType } from "../constants/mapCharacteristics";
import {
  getMapCharacteristicsApi,
  addCharacteristicApi,
  changeRateApi
} from "../../api/mapCharacteristics/mapCharacteristics";

export const getMapCharacteristicsAction = (map_id, page = "1", allowActionsHandler, newData) => dispatch => {
  return getMapCharacteristicsApi(map_id, page)
    .then(
      dispatch({
        type: ActionType.GET_CHARACTERISTICS_START
      })
    )
    .then(response => {
      const calculatePercent = (up, down) => {
        const commonCount = up + down
        if (up && up !== 0) {
          return up * 100 / commonCount
        }
        if (commonCount === 0) return 0
        if (up === 0 && down !== 0) return 1
        else return 0
      }
      const res = response.data.items
        .map(obj => ({ ...obj, upPercent: calculatePercent(obj.count_like, obj.count_dislike) }))
        .sort((a, b) => (a.upPercent > b.upPercent) ? 1 : ((b.upPercent > a.upPercent) ? -1 : 0)).reverse();
      return dispatch({
        type: ActionType.GET_CHARACTERISTICS_SUCCESS,
        payload: res,
        newData: newData
      });
    })
    .then(() => {
      allowActionsHandler();

    })
    .catch(error => {
      dispatch({
        type: ActionType.GET_CHARACTERISTICS_ERRORS,
        payload: error.response
      });
    });
};

export const addCharacteristicAction = (data, success_action) => dispatch => {
  return addCharacteristicApi(data)
    .then(response => {
      success_action();
      dispatch({
        type: ActionType.ADD_CHARACTERISTICS_ITEM_SUCCESS,
        payload: response.data
      });
    })
    .catch(error => {
      dispatch({
        type: ActionType.ADD_CHARACTERISTICS_ITEM_ERRORS,
        payload:
          error.response && error.response.data && error.response.data.errors
            ? error.response.data.errors
            : {}
      });
    });
};

export const changeRateAction = (data, updateDataHandler) => dispatch => {
  return changeRateApi(data)
    .then(response => {
      return dispatch({
        type: ActionType.CHANGE_RATE_SUCCESS,
        payload: response.data
      })
    })
    .then(() => {
      updateDataHandler();
    })
    .catch(error => {
      dispatch({
        type: ActionType.CHANGE_RATE_ERRORS,
        payload: error.response
      });
    });
};

export const setDescriptionValueAction = value => dispatch => {
  return dispatch({
    type: ActionType.SET_DESCRIPTION_VALUE,
    payload: value
  });
};

export const clearDescriptionFieldAction = () => dispatch => {
  return dispatch({
    type: ActionType.CLEARE_DESCRIPTION_FIELD
  });
};

export const cleanDescriptionErrorsAction = () => dispatch => {
  return dispatch({
    type: ActionType.DECRIPTION_ERRORS_CLEANER
  });
};
